import { useCallback, useState } from 'react';
import { t } from '@lingui/macro';
import { isEmpty, merge } from 'lodash';

import DataTable from '../../data-table/DataTable';
import AdminPage from '../AdminPage';
import { AdminPages, buildPageId } from '../AdminLinkUtils';
import { SELECTIONMODE_MULTI, SELECTIONMODE_NONE } from '../../data-table/SelectionContext';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { useQueryLoader } from '../../data-table/Loaders';
import { useIntervalRefreshTrigger } from '../../data-table/Triggers';
import { useIsSysAdminUser } from '../../../stores/SessionStore';
import { Actions } from '../../page-framework';
import ConfirmDeleteButton from '../../form/ConfirmDeleteButton';
import { useFormDeleteService, useFormDeleteWrapper } from '../../../services/FormDeleteService';
import { getDashboardListColumns } from './DashboardsAdminConstants';

const functionName = AdminPages.Dashboards;

const initialSort = [{ property: 'title', direction: SORT_ASC }];
const dataSource = {
    url: '/ipm/v1/admin/dashboards',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: ['title'],
    },
};

export default function DashbaordsAdminList() {
    const [actionsDisabled, setActionsDisabled] = useState(true);
    const [tableSelection, setTableSelection] = useState(undefined);
    const [tableState, setTableState] = useState(undefined);
    const loader = useQueryLoader(dataSource, { disableFilterState: true });
    const formDeleteService = useFormDeleteService();
    const { deleteWrapper } = useFormDeleteWrapper();
    const { triggerRef, trigger: refresher } = useIntervalRefreshTrigger();
    const [isSysAdmin] = useIsSysAdminUser();

    const handleTableSelectionChange = useCallback((currentTableSelection) => {
        const disableActions =
            !currentTableSelection || (isEmpty(currentTableSelection?.selection) && !currentTableSelection.inverted);

        setTableSelection(currentTableSelection);
        setActionsDisabled(disableActions);
    }, []);

    const handleConfirmedDelete = () => {
        const params = merge(
            {
                search: tableState?.search || '',
            },
            dataSource.params
        );

        return deleteWrapper({
            deleteFunction: () =>
                formDeleteService.deleteSelection(`${dataSource.url}/selection/remove`, params, tableSelection),
            refresherFunc: refresher,
        })();
    };

    return (
        <AdminPage
            title={t`Dashboards`}
            pageId={buildPageId(functionName)}
            actions={
                <Actions>
                    {isSysAdmin && (
                        <ConfirmDeleteButton
                            disabled={actionsDisabled}
                            handleConfirmedDelete={handleConfirmedDelete}
                            plural={tableSelection?.selection?.length > 1}
                        />
                    )}
                </Actions>
            }
        >
            <DataTable
                tableId="admin-dashboards-list"
                loader={loader}
                columns={getDashboardListColumns(isSysAdmin)}
                triggerRef={triggerRef}
                visibleRows={0}
                showSelectionColumn={isSysAdmin}
                sorters={initialSort}
                onStateChanged={setTableState}
                selectionOptions={{
                    mode: isSysAdmin ? SELECTIONMODE_MULTI : SELECTIONMODE_NONE,
                    allowSelectAll: true,
                    idMapping: '_id',
                    onChange: handleTableSelectionChange,
                }}
            />
        </AdminPage>
    );
}
